import { SerializedStyles, css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MAX_AVATARS_IN_GALLERY } from './JoinProduct';

const AVATAR_GALLERY_STYLES_OFFSET = 12;

export const joinContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  > div {
    display: flex;
    flex-direction: row;
  }
`;

export const avatarsContainer = (avatarsLength: number): SerializedStyles => css`
  padding-left: ${avatarsLength < MAX_AVATARS_IN_GALLERY
    ? avatarsLength * AVATAR_GALLERY_STYLES_OFFSET
    : MAX_AVATARS_IN_GALLERY * AVATAR_GALLERY_STYLES_OFFSET}px;
  margin-bottom: var(${SpacingToken.Spacing8});
`;

export const avatar = (avatarsLength: number, index: number): SerializedStyles => css`
  border: var(${SpacingToken.Spacing1}) solid var(${DesignToken.SurfacePrimaryDefault});
  left: ${index < MAX_AVATARS_IN_GALLERY - 1
    ? -1 * AVATAR_GALLERY_STYLES_OFFSET * index
    : -1 * (MAX_AVATARS_IN_GALLERY - 1) * AVATAR_GALLERY_STYLES_OFFSET}px;
  z-index: ${avatarsLength - index};
`;

export const accountsCounter = () => css`
  position: relative;
  width: 64px;
  height: 64px;
  border: var(${SpacingToken.Spacing1}) solid var(${DesignToken.SurfacePrimaryDefault});
  display: flex;
  justify-content: center;
  align-items: center;
  left: ${-1 * (MAX_AVATARS_IN_GALLERY - 1) * AVATAR_GALLERY_STYLES_OFFSET}px;
  background-color: var(${DesignToken.SurfaceTertiaryDefault});
  color: var(${DesignToken.ContentBasicPrimary});
  border-radius: 50%;
  margin: 0;
`;

export const header = css`
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const description = css`
  margin-bottom: var(${SpacingToken.Spacing7});
`;

export const joinBlockedContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const otherProducts = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  margin-top: var(${SpacingToken.Spacing12});

  > div {
    display: flex;
    justify-content: center;
    gap: var(${SpacingToken.Spacing2});
  }
`;
